export default {
  "apiKey": "AIzaSyAZ2LLOKlzM7Uw2jpWl1q6setM_Y0QEuqI",
  "authDomain": "dartbid-75d6c.firebaseapp.com",
  "databaseURL": "https://dartbid-75d6c-default-rtdb.firebaseio.com",
  "projectId": "dartbid-75d6c",
  "storageBucket": "dartbid-75d6c.appspot.com",
  "messagingSenderId": "768255588201",
  "appId": "1:768255588201:web:58983ed31f9ec31381eff8",
  "measurementId": "G-7BGYH24BJX"
};